/* eslint-disable no-case-declarations */
/* eslint-disable array-callback-return */

import {
  GET_AUTHORIZATION_COMMENTS_SUCCESS,
  POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS
} from '../types/authorizationTypes';

const handleCommentsAndNotesReducer = (draft, action) => {
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].commentsAndNotes) {
    draft.authorizationDetails[draft.currentAuthId].commentsAndNotes = [];
    draft.authorizationDetails[draft.currentAuthId].commentsAndNotesWithAttachments = [];
  }

  switch (action.type) {
    case GET_AUTHORIZATION_COMMENTS_SUCCESS:
      var commentsAndNotes = [];
      action.response.map(comment => {
        commentsAndNotes.push(comment.info);
      });
      draft.authorizationDetails[draft.currentAuthId].commentsAndNotes = commentsAndNotes;
      draft.authorizationDetails[draft.currentAuthId].commentsAndNotesWithAttachments = action.response;
      break;

    case UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
    case DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
    case POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
      const currentCommentIndex = draft.authorizationDetails[draft.currentAuthId].commentsAndNotesWithAttachments.findIndex(comment => comment.info.commentId === action.context.commentId);
      draft.authorizationDetails[draft.currentAuthId].commentsAndNotesWithAttachments[currentCommentIndex].attachments = action.response;
      break;

    default:
      break;
  }
  return draft;
};

export default handleCommentsAndNotesReducer;